import { useRef } from 'react';
import { useAnimationFrame } from '../hooks';
import type { VoiceController } from '../voice/VoiceController';

const SEGMENTS = 16;

/** Segmented, block-style microphone level meter, driven by rAF without React re-renders. */
export function MicMeter({ controller, active }: { controller: VoiceController; active: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  const smooth = useRef(0);
  useAnimationFrame(() => {
    const el = ref.current;
    if (!el) return;
    const level = controller.getMicLevel();
    // fast attack, slow release
    smooth.current = level > smooth.current ? level : smooth.current * 0.88 + level * 0.12;
    const lit = Math.round(Math.min(1, Math.sqrt(smooth.current)) * SEGMENTS);
    el.dataset.level = String(lit);
    const kids = el.children;
    for (let i = 0; i < kids.length; i++) kids[i]!.classList.toggle('on', i < lit);
  });
  return (
    <div
      ref={ref}
      className={`mic-meter${active ? '' : ' is-muted'}`}
      data-testid="mic-level"
      role="meter"
      aria-label="Livello del microfono"
      aria-valuemin={0}
      aria-valuemax={SEGMENTS}
    >
      {Array.from({ length: SEGMENTS }, (_, i) => (
        <span key={i} className={i >= SEGMENTS - 3 ? 'hot' : i >= SEGMENTS - 7 ? 'warm' : ''} />
      ))}
    </div>
  );
}
